import { Link } from 'react-router-dom';
import { Comic } from '@/mocks/comics';

interface LatestUpdatesProps {
  comics: Comic[];
}

export default function LatestUpdates({ comics }: LatestUpdatesProps) {
  const formatDate = (dateStr: string): string => {
    const date = new Date(dateStr);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    if (diffDays === 0) return '今天更新';
    if (diffDays === 1) return '昨天更新';
    if (diffDays < 7) return `${diffDays}天前`;
    return dateStr;
  };

  const formatViews = (views: number): string => {
    if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
    return views.toString();
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
      {comics.map((comic) => (
        <Link
          key={comic.id}
          to={`/comic/${comic.id}`}
          className="group flex gap-4 p-4 rounded-lg bg-background-50 border border-background-200/60 hover:border-primary-200/50 transition-all duration-200 cursor-pointer"
        >
          <div className="relative w-20 sm:w-24 flex-shrink-0 overflow-hidden rounded-lg aspect-[3/4]">
            <img
              src={comic.coverImage}
              alt={`${comic.title} - 韩漫免费在线阅读`}
              title={`${comic.title} - 韩漫网`}
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              loading="lazy"
            />
          </div>
          <div className="flex-1 min-w-0 flex flex-col justify-between">
            <div>
              <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1 line-clamp-2 leading-relaxed">
                {comic.description}
              </p>
            </div>
            <div className="flex items-center gap-3 mt-2">
              <span className="text-xs text-accent-600 font-medium whitespace-nowrap">
                {formatDate(comic.updateDate)}
              </span>
              <span className="text-xs text-foreground-400">{formatViews(comic.views)}阅读</span>
              <span className={`px-1.5 py-0.5 rounded text-xs font-medium ${
                comic.status === '连载中'
                  ? 'bg-accent-100 text-accent-700'
                  : 'bg-secondary-100 text-secondary-700'
              }`}>
                {comic.status}
              </span>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}